import React from 'react';

interface LoadingSpinnerProps {
  size?: string;
  height?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'w-12 h-12', height = 'h-80' }) => {
  return (
    <div className={`w-full ${height} flex justify-center items-center`}>
      <img className={size} src="/loading.gif" alt="Loading" />
    </div>
  );
};

export default LoadingSpinner;
